import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModalComponent } from './ui-modal/ui-modal.component';
import { AnimationModalComponent } from './animation-modal/animation-modal.component';
import { ModalComponent } from './modal/modal.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    UiModalComponent,
    AnimationModalComponent,
    ModalComponent
  ],
  exports: [
    UiModalComponent,
    AnimationModalComponent,
    ModalComponent
  ]
})
export class ModalModule { }
